import React, { useState } from "react";
import { View, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/Feather";

import { CameraMenu } from "components";
import { Device, FilePicker } from "utils";

import { styles } from "./styles";

export const MediaTray = props => {
  const { photo, video, audio, onCapture: _onCapture } = props;
  const [popupVisible, setPopupVisible] = useState(false);
  const onCapture = (file, type) => {
    _onCapture(file, type);
    setPopupVisible(false);
  };
  return (
    <>
      <View style={styles.textBoxIcon}>
        {(photo || video) &&
          (Device.IS_MOBILE_WEB ? (
            <FilePicker photo={photo} video={video} onCapture={onCapture}>
              <View style={styles.iconContainer}>
                <Icon
                  name="camera"
                  size={styles._icon?.fontSize}
                  color={styles._icon?.color}
                />
              </View>
            </FilePicker>
          ) : (
            <TouchableOpacity
              onPress={() => setPopupVisible(!popupVisible)}
              style={styles.iconContainer}
            >
              <Icon
                name="camera"
                size={styles._icon?.fontSize}
                color={styles._icon?.color}
              />
            </TouchableOpacity>
          ))}
        {audio && Device.IS_WEB_AUDIO_SUPPORTED && (
          <TouchableOpacity
            style={styles.iconContainer}
            onPress={props.enableAudio}
          >
            <Icon
              name="mic"
              size={styles._icon?.fontSize}
              color={styles._icon?.color}
            />
          </TouchableOpacity>
        )}
        {popupVisible && (
          <CameraMenu photo={photo} video={video} onCapture={onCapture} />
        )}
      </View>
    </>
  );
};
